import React from 'react';
import CreateSegment from '../components/CreateSegment';

const CreateSegmentContainer = () => {
  return (
    <React.Fragment>
      <CreateSegment showUseSegment={false} />
    </React.Fragment>
  );
};

export default CreateSegmentContainer;
